<script setup lang="ts">
import { computed } from 'vue';
import DropdownItem from '../common/DropdownItem.vue';
import { IconBaselineMap } from '@iconify-prerendered/vue-ic';
import type { MenuItem } from 'primevue/menuitem';
import { storeToRefs } from 'pinia';
import { useMapStyleStore } from 'shared/mapStyles/stores/mapStyleStore';
import { useLanguageStore } from 'shared/translations/stores/languageStore';

const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);

const mapStyleStore = useMapStyleStore();
const { selectedStyle } = storeToRefs(mapStyleStore);

const items = computed<MenuItem[]>(() => mapStyleStore.styles.map(s => {
  return {
    label: s.name,
    command: () => {
      mapStyleStore.selectedStyleId = s.id;
    },
  };
}));

</script>

<template>
  <DropdownItem
    :title="translations.settings.map.style"
    :description="selectedStyle?.name ?? ''"
    :items="items"
  >
    <template #icon>
      <IconBaselineMap style="width: 2rem; height: 2rem"></IconBaselineMap>
    </template>
  </DropdownItem>
</template>
